var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCaprxStackedWhiteSmallC = function SvgCaprxStackedWhiteSmallC(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 159,
    height: 119,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.804.35H18.91V31H.804z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 40h159V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.585.52H25V30H.585z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 79)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.34 19.564c-1.378 0-3.18-.596-5.037-2.195V6.258c2.015-1.897 3.791-2.9 5.541-2.9 3.896 0 5.46 3.144 5.46 7.805 0 5.23-2.544 8.4-5.964 8.4M10.692.35c-2.412 0-4.719 1.382-6.6 2.98h-.106L3.694.893H.804V31h3.5v-7.182l-.107-3.686c1.91 1.572 3.844 2.466 5.753 2.466 4.745 0 8.96-4.227 8.96-11.436C18.91 4.605 16.047.35 10.692.35",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.928.894c-1.352 0-2.413.895-2.413 2.304 0 1.355 1.06 2.303 2.413 2.303 1.352 0 2.412-.975 2.412-2.303.026-1.409-1.034-2.304-2.412-2.304"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M64.151 31.056h3.5V9.864h-3.5zM112.901 29.241l-.133-.732c-.397.082-.556.082-.768.082-.504 0-.98-.434-.98-1.545V0h-3.5v26.802c0 3.062 1.087 4.77 3.711 4.77.928 0 1.511-.163 2.015-.326l-.159-.975-.186-1.03zM81.329 28.645c-2.386 0-3.208-1.49-3.208-4.092V12.791h5.621V9.864h-5.621V3.93h-2.916l-.423 5.934-3.235.217v2.71h3.075V24.5c0 4.227 1.485 7.073 5.912 7.073 1.299 0 2.677-.38 3.844-.786l.371-.163a7.678 7.678 0 0 1-1.246-2.466c-.663.271-1.511.488-2.174.488M12.46 5.122c2.358 0 4.214 1.084 5.672 2.71l1.961-2.358C18.45 3.631 15.8 1.951 12.406 1.951 5.301 1.951 0 7.588 0 16.802 0 26.098 5.222 31.6 12.194 31.6c2.332 0 4.294-.623 5.991-1.762a7.48 7.48 0 0 1-.955-3.143c-1.405 1.084-2.995 1.707-4.904 1.707-5.302 0-8.668-4.499-8.668-11.68 0-7.155 3.526-11.599 8.801-11.599M99.594 25.881c-2.015 1.815-3.658 2.791-5.673 2.791-2.041 0-3.632-.976-3.632-3.387 0-2.711 2.36-4.445 9.279-5.312v5.908h.026zM95.909 9.35c-3.313 0-6.23 1.49-8.138 2.764l1.379 2.466c1.617-1.111 3.79-2.277 6.176-2.277 3.393 0 4.268 2.629 4.268 5.339-8.827.976-12.724 3.28-12.724 7.914 0 3.821 2.598 6.016 6.07 6.016 2.57 0 4.878-1.382 6.84-3.063h.106l.29 2.521h2.89V18.049c.054-5.258-2.094-8.699-7.157-8.699zM33.852 25.881c-2.015 1.815-3.658 2.791-5.646 2.791-2.041 0-3.632-.976-3.632-3.387 0-2.711 2.359-4.445 9.278-5.312v5.908zM30.167 9.35c-3.314 0-6.23 1.49-8.138 2.764l1.378 2.466c1.617-1.111 3.79-2.277 6.177-2.277 3.393 0 4.268 2.629 4.268 5.339-8.828.976-12.725 4.418-12.725 7.914 0 3.821 2.599 6.016 6.07 6.016 2.572 0 4.879-1.382 6.84-3.063h.107l.29 2.521h2.89V18.049c.053-5.258-2.094-8.699-7.157-8.699zM131.457 15.854h-4.692V5.258h4.692c4.347 0 6.76 1.328 6.76 5.095-.027 3.686-2.413 5.5-6.76 5.5zM159 31.166l-5.725-9.08 5.408-8.671h-3.738l-3.87 6.396-3.845-6.396h-3.79l5.355 8.59c-.186.353-.61 1.112-1.114 1.952l-.503.786c-.584.894-1.22 1.789-1.803 2.412-1.538 1.599-3.87 1.436-5.222-.19-1.538-1.87-4.666-8.59-4.666-8.59 3.791-.95 6.283-3.605 6.283-8.05 0-5.961-4.083-8.048-9.782-8.048h-8.774v28.59h3.552V18.782h5.063c.08 0 .504 1.138.557 1.246.477 1.03.954 2.033 1.458 3.063 1.087 2.168 2.2 4.634 3.79 6.477 1.3 1.463 3.235 2.086 5.541 2.086 1.617 0 3.207-.65 4.268-1.788 1.245-1.382 3.128-4.174 3.711-5.393l4.11 6.72h3.736v-.026z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M93.792 0L81.585 14.778 93.792 29.52 106 14.78z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81 29)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.585 15.26L12.792 30 25 15.26 12.792.52z",
    mask: "url(#f)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M69.415 0L57.207 14.779 45 29.52l12.207 14.74L69.415 59h24.376L81.585 44.26l-12.17-14.74 12.17-14.742L93.791.002z"
  }))));
};
export { SvgCaprxStackedWhiteSmallC as ReactComponent };
export default __webpack_public_path__ + "static/media/caprx-stacked-white-small-c.f4d827bf.svg";